import { OperationHistoryDetailsModal } from '../ui';
import type { OperationDto } from '@/shared/types';
import { useModalStore } from '@/shared/lib';

type Params = {
  operation: OperationDto;
  onStatusChange?: () => void;
};

export function useOperationHistoryDetailsModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openOperationDetailsModal = ({ operation, onStatusChange }: Params) => {
    showDialogComponent({
      component: (
        <OperationHistoryDetailsModal
          operation={operation}
          onClose={closeDialog}
          onStatusChange={onStatusChange}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  }; 

  return { openOperationDetailsModal };
}
